import { render } from "./CourseTypeSelectHost.vue?vue&type=template&id=4c694f55"
import script from "./CourseTypeSelectHost.vue?vue&type=script&lang=js"
export * from "./CourseTypeSelectHost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__